import React, { Component } from "react";
import EditableDataContainer from "../containers/EditableDataContainer";
import ApiConfig from "../config/ApiConfig";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import { bool, object } from "yup";
import PURCHASEIRQUSCitizenView from "../views/IrqCitizenView";
import StatusCheck from "../components/StatusCheck";

class BuildIrqUsCitizenPage extends Component {
  render() {
    const submitEndpoint =
      ApiConfig.protocol + ApiConfig.apiUri + ApiConfig.irqEndpoint;

    return (
      <div className="page-wrapper">
        <StatusCheck />
        <EditableDataContainer
          id="buildIrq"
          submitEndpoint={submitEndpoint}
          mutateRedux="always"
          isCreate
          isStep
          validationSchema={object().shape({
            isUsCitizen: bool().required(),
          })}
        >
          <PURCHASEIRQUSCitizenView
            content={contentMap.BuildIrqUsCitizenPage}
            navigationsAway={customNavigationMap.BuildIrqUsCitizenPage}
          />
        </EditableDataContainer>
      </div>
    );
  }
}

export default withRouterUtilities(BuildIrqUsCitizenPage);
